import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-224d5a23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Assessment Score", -1))
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left-circle" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "overlay-layer text-center rounded"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "w-100 text-center h5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ScoreChart = _resolveComponent("ScoreChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/home",
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["card-body pt-0", _ctx.data ?? 'overlay-block'])
    }, [
      (!_ctx.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.data)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_ScoreChart, {
                  with: 270,
                  max: _ctx.data.max_score,
                  num: 'main',
                  score: _ctx.data.score,
                  percent: _ctx.data.percent,
                  info: "sasa",
                  description: "assa"
                }, null, 8, ["max", "score", "percent"])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_ctx.data.section.length / 3), (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: i
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.section.slice((i - 1) * 3, i * 3), (item, j) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-4",
                    key: j
                  }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.description), 1),
                    _createVNode(_component_ScoreChart, {
                      with: 240,
                      max: item.max,
                      num: 'num'+item.num,
                      score: item.score,
                      percent: item.percent,
                      info: "sasa",
                      description: "assa"
                    }, null, 8, ["max", "num", "score", "percent"])
                  ]))
                }), 128))
              ]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}